$(document).ready(function () {
  // Target any accordion wrapper that has an ID
  $(".new-faq-accordion").each(function () {
    let $accordion = $(this); // get the current accordion by its id

    // hide all bodies inside this accordion
    $accordion.find(".faq-answers").hide();

    // add click event inside this accordion
    $accordion.find(".faq-question ").click(function () {
      let $this = $(this);
      let $body = $this.next(".faq-answers");

      if ($body.is(":visible")) {
        $body.slideUp();
        $this.removeClass("active");
      } else {
        // close all first inside this accordion only
        $accordion.find(".faq-answers").slideUp();
        $accordion.find(".faq-question ").removeClass("active");

        // open clicked one
        $body.slideDown();
        $this.addClass("active");
      }
    });
  });

  // Hide all contents, show only the first
  $(".new-product-detail__content-body").hide();
  $(".new-product-detail__content-body:first").css('display','block');

  // Set first tab as active
  $(".new-product-detail__tab li:first").addClass("active");

  // Tab click event
  $(".new-product-detail__tab li").on("click", function() {
      var tabId = $(this).data("id"); // Get clicked tab id

      // Remove active class from all tabs, add to clicked one
      $(".new-product-detail__tab li").removeClass("prev-li");
      $(".new-product-detail__tab li").removeClass("active");
      $(this).prev('li').addClass('prev-li');
      $(this).addClass("active");

      // Hide all contents, show the matching one
      $(".new-product-detail__content-body").hide();
      $("#" + tabId).fadeIn();
  });

  if($('.js-after-before-slider').length > 0){
    $('.js-after-before-slider').slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 1199,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2.5,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.5,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ]
    });
  }
});
